<template>
  <IconLucideCheck />
</template>
